export const marketerRoute = [
  { path: "/submission", component: "SubmissionList" },
  { path: "/submissionDetail/:id", component: "SubmissionDetail" },
  { path: "/wellskyclients", component: "PatientList" },
  { path: "/marketers", component: "MarketersList" },
  { path: "/profile", component: "ProfilePage" },
  { path: "/change-password", component: "ChangePasswordPage" },
];

export const staffRoute = [
  { path: "/dashboard", component: "Dashboard" },
  { path: "/submission", component: "SubmissionList" },
  { path: "/submissionDetail/:id", component: "SubmissionDetail" },
  { path: "/wellskyclients", component: "PatientList" },
  { path: "/marketers", component: "MarketersList" },
  { path: "/profile", component: "ProfilePage" },
  { path: "/change-password", component: "ChangePasswordPage" },
];

export const adminRoute = [
  { path: "/dashboard", component: "Dashboard" },
  { path: "/submission", component: "SubmissionList" },
  { path: "/manageSubmission/:id", component: "ManageSubmission" },
  { path: "/wellskyclients", component: "PatientList" },
  { path: "/clientdetail/:id", component: "PatientDetail" },
  { path: "/state-city", component: "StateAndCityList" },
  { path: "/users", component: "UsersList" },
  { path: "/marketers", component: "MarketersList" },
  { path: "/profile", component: "ProfilePage" },
  { path: "/change-password", component: "ChangePasswordPage" },
];
